// services/bulk-update.service.ts
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpEventType } from '@angular/common/http';

export interface BulkProgress {
  status: string;
  result?: any;
}

@Injectable({ providedIn: 'root' })
export class ServerSentEventService {

  constructor(
    readonly http: HttpClient,
  ) {}

  /*
  Needs to be called like this:
     '/api/parcels/bulk-update',
     {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ record_ids: recordIds, ...payload })
      }
   */

  bulkUpdateWithProgress(
    url: string,
    apiInput: any
  ): Observable<BulkProgress> {
    return new Observable<BulkProgress>(observer => {
      let lastLength = 0;
      // HttpClient handles auth, token refresh, body serialization, etc.
      this.http.post(url, apiInput, {
        responseType: 'text',
        observe: 'events',
        reportProgress: true,
      }).subscribe({
        next: (event) => {
          // HttpClient chunked download events
          if (event.type === HttpEventType.DownloadProgress) {
            const partial = (event as any).partialText as (string | undefined);
            const newChunk = partial.slice(lastLength);  // only process new content
            lastLength = partial.length;

            const lines = newChunk.split('\n\n');
            for (const line of lines) {
              const dataLine = line.replace(/^data: /, '').trim();
              if (dataLine) {
                try {
                  observer.next(JSON.parse(dataLine));
                } catch (e) {
                }
              }
            }
          }
          if (event.type === HttpEventType.Response) {
            observer.complete();
          }
        },
        error: (err) => observer.error(err)
      });
    });
  }
}
